import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { useState } from "react";
import { Field, Form, Formik, FormikHelpers } from "formik";
import axios from "axios";
import { FormButton } from "./PasswordRecoveryStyles";
import { Loader } from "../../../components/Loader/Loader";
import { ArticleBlock, FormMainBlock } from "../FormsGeneralStyles";
import { useAppSelector } from "../../../store/hooks";
import { PasswordRecoveryFormValues } from "../../../interfaces/PasswordRecoveryInterface";
import { useNavigate, useResolvedPath } from "react-router-dom";

export const PasswordRecovery = () => {
  const [isSuccess, setSuccess] = useState(false);
  const [inProgress, setInProgress] = useState(false);
  const lang = useAppSelector((state) => state.locale.localStorageValue);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const resolvedPath = useResolvedPath(
    lang === "en"
      ? "/auth/forgot-password/email-successfully"
      : `/${lang}/auth/forgot-password/email-successfully`
  );

  const handleSubmit = async (
    values: PasswordRecoveryFormValues,
    formikHelpers: FormikHelpers<PasswordRecoveryFormValues>
  ) => {
    setInProgress(true);
    setSuccess(false);

    try {
      const response = await axios.post(
        "https://api.demo-q17.com/auth/forgot",
        { email: values.email },
        {
          headers: {
            "Content-Type": "application/json",
            "Accept-Language": lang,
            "Accept": "application/json",
          },
        }
      );

      setSuccess(true);

      navigate(resolvedPath.pathname);
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const { status, data } = error.response;

        if (status === 422 && data.errors) {
          Object.keys(data.errors).forEach((field) => {
            formikHelpers.setFieldError(field, data.errors[field]);
          });
        }

        if (status === 429) {
          alert(t("formsWarnings.tooManyRequests"));
        }
      } else {
        console.error("Unexpected error:", error);
      }
    } finally {
      setInProgress(false);
    }
  };

  const DisplayingErrorMessagesSchema = Yup.object().shape({
    email: Yup.string()
      .email(t("formsWarnings.invalidEmail"))
      .required(t("formsWarnings.emailRequired")),
  });

  return (
    <main>
      <FormMainBlock>
        <section>
          <div className="container__standart div__container">
            <div className="div__form">
              <h3>{t("passwordRecoveryPage.title1")}</h3>
              <Formik
                initialValues={{
                  email: "",
                }}
                validationSchema={DisplayingErrorMessagesSchema}
                onSubmit={handleSubmit}
              >
                {({ errors, touched }) => (
                  <Form className="form__content">
                    <ArticleBlock>
                      <div className="div__main__block">
                        <Field
                          id="email"
                          name="email"
                          placeholder={t("form.mail")}
                          type="text"
                          className={`input__styles ${
                            touched.email && errors.email && "!border-[#eb5757]"
                          }`}
                        />
                        {touched.email && errors.email && (
                          <span className="form__req__info password__error">
                            {errors.email}
                          </span>
                        )}
                      </div>
                    </ArticleBlock>
                    <div>
                      {inProgress ? (
                        <Loader height="41" width="100%" />
                      ) : (
                        <FormButton
                          type="submit"
                          className="white__button flex__center log__btn"
                        >
                          {isSuccess
                            ? t("form.successfully")
                            : t("form.restore")}
                        </FormButton>
                      )}
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </section>
      </FormMainBlock>
    </main>
  );
};
